import useGA4Ecommerce from 'hooks/useGA4Ecommerce';
import useGtmEventEnabled from 'hooks/useGtmEventEnabled';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { EVENT_GTM_PRODUCT_ADD_TO_CART } from 'Component/GoogleTagManager/GoogleTagManager.events';

import { EVENT_GA4_ADD_TO_CART } from '../../../eventData/ga4/GA4.events';
import { getAddToCartEventDataFromSelection } from '../../../eventData/ga4/product.data';

/**
 * Fires the GA4 `add_to_cart` event for a direct PDP/PLP "Add to cart"
 * click. Gated on the same backend toggle the legacy container used for
 * this event (`gtm_product_add_to_cart` — unlike `view_cart`, this one IS
 * part of GoogleTagManagerQuery.getEvents()).
 *
 * @namespace Bodypwa/Component/AddToCart/Hooks/UseAddToCartGtmEvent/useAddToCartGtmEvent
 */
export function useAddToCartGtmEvent() {
    const { pushEcommerceEvent } = useGA4Ecommerce();
    const isEnabled = useGtmEventEnabled(EVENT_GTM_PRODUCT_ADD_TO_CART);
    const currency = useSelector((state) => state.ConfigReducer.currencyData?.current_currency_code);

    return useCallback((product, selectedProduct, quantity) => {
        if (!isEnabled) {
            return;
        }

        pushEcommerceEvent(
            EVENT_GA4_ADD_TO_CART,
            getAddToCartEventDataFromSelection({
                product, selectedProduct, quantity, currency
            })
        );
    }, [isEnabled, currency, pushEcommerceEvent]);
}

export default useAddToCartGtmEvent;
